/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ZipLookupResult } from './ZipLookupResult';
import {
    ZipLookupResultFromJSON,
    ZipLookupResultFromJSONTyped,
    ZipLookupResultToJSON,
    ZipLookupResultToJSONTyped,
} from './ZipLookupResult';

/**
 * 
 * @export
 * @interface ZipLookupResponse
 */
export interface ZipLookupResponse {
    /**
     * 
     * @type {Array<ZipLookupResult>}
     * @memberof ZipLookupResponse
     */
    data: Array<ZipLookupResult>;
}

/**
 * Check if a given object implements the ZipLookupResponse interface.
 */
export function instanceOfZipLookupResponse(value: object): value is ZipLookupResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ZipLookupResponseFromJSON(json: any): ZipLookupResponse {
    return ZipLookupResponseFromJSONTyped(json, false);
}

export function ZipLookupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZipLookupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ZipLookupResultFromJSON)),
    };
}

export function ZipLookupResponseToJSON(json: any): ZipLookupResponse {
    return ZipLookupResponseToJSONTyped(json, false);
}

export function ZipLookupResponseToJSONTyped(value?: ZipLookupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ZipLookupResultToJSON)),
    };
}

